import EdReadyReaderNode from './types/edReady-ready';

export const edReadyNodes = {
  edReadyReader: EdReadyReaderNode,
};
